<template>
  <div class="popularize-duba-huyan-wrap">
    <video
      src="//wallpaperm-mp4.duba.com/live/video/828a818e884bd72b3d5c86da6d1c1e4c.mp4"
      loop
      muted
      autoplay
    />
  </div>
</template>

<script>
export default {
  name: 'PopularizeDubaHuyan',
  data() {
    return {
    }
  },
  methods: {
  },
}
</script>

<style lang="scss" scoped>
.popularize-duba-huyan-wrap {
  z-index: 20;
  position: fixed;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  video {
    width: 100%;
    height: 100%;
  }
}
</style>
